<template>
	<div class="row">
		<template v-if="hasSlot">
			<div class="card__content">
				<div class="col-lg-8 col-md-12 col-sm-12" style="direction: ltr;">
					<slot name="fields"></slot>
				</div>
				<div class="col-lg-4 col-md-12 col-sm-12 text-center">
					<input id="pac-input" class="controls" type="text" ref="searchBox" :placeholder="placeholder" />
					<google-map
						ref="map"
						@click="e => {addMarker(e.latLng, true)}"
						:center="center"
						:zoom="8"
						style="width: 100%; height: 100%"
                        :options="options"
					>
						<google-marker
							v-for="(m, index) in markers"
							:position="m.position"
							:clickable="!true"
							:draggable="!true"
							:key="index"
						></google-marker>
					</google-map>
				</div>
			</div>
		</template>

		<template v-else>
			<div class="col-12 map--container" :style="getHeight()">
				<input id="pac-input" class="controls" type="text" ref="searchBox" :placeholder="placeholder" />
				<google-map
                    :options="options"
					ref="map"
					@click="e => addMarker(e.latLng, true)"
					:center="center"
					:zoom="8"
					style="width: 100%; height: 100%"
				>
					<google-marker
						v-for="(m, index) in markers"
						:position="m.position"
						:clickable="!true"
						:draggable="!true"
						:key="index"
					></google-marker>
				</google-map>
			</div>
		</template>
	</div>
</template>
<script>
export default {
	name: 'geolocation',
	props: {
		title: {
			type: String,
			default: () => '',
		},
		lng: {
			// type: Number,
			default: () => 0,
		},
		lat: {
			// type: Number,
			default: () => 0,
		},
		height: {
			default: () => 0
		}
	},

	data() {
		return {
			markers: [],
			center: {
				lat: 30.037085310164322,
				lng: 31.239552484750448,
			},
			placeholder: 'Search for place',
            options: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false
            },
		}
	},
	methods: {
		addMarker(latLng, emit = false) {
			let mark
			this.markers = []

			if (latLng.lat && latLng.lng) {
				latLng = is_func(latLng.toJSON)
					? latLng.toJSON()
					: {
							lat: parseFloat(latLng.lat),
							lng: parseFloat(latLng.lng),
					}
				mark = {
					position: {
						lat: latLng.lat,
						lng: latLng.lng,
					},
				}

				this.markers.push(mark)
				if (emit) {
					this.$emit('onChangeMarker', latLng)
					this.$refs.searchBox ? (this.$refs.searchBox.value = '') : void 0
				}
			}
		},

		getHeight() {
			console.log(this.height);
			
			return (this.height) ? `height: ${this.height}px !important` : 'height: 240px !important';
		}
	},
	watch: {
		title(value) {
			//
		},
		lng(value) {
			this.addMarker({
				lng: value,
				lat: this.lat,
			})
		},

		lat(value) {
			this.addMarker({
				lng: this.lng,
				lat: value,
			})
		},
	},
	mounted() {
		if (this.lng && this.lat) {
			this.addMarker({
				lat: this.lat,
				lng: this.lng,
			})
		}

		if (this.$refs.searchBox) {
			// Create the search box and link it to the UI element.

			this.$refs.map &&
				this.$refs.map.$mapPromise.then((map) => {
					var input = this.$refs.searchBox
					var searchBox = new google.maps.places.SearchBox(input)

					map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

					// Bias the SearchBox results towards current map's viewport.
					map.addListener('bounds_changed', function() {
						searchBox.setBounds(map.getBounds())
					})

					// Listen for the event fired when the user selects a prediction and retrieve
					// more details for that place.
					searchBox.addListener('places_changed', function() {
						var places = searchBox.getPlaces()

						if (places.length == 0) {
							return
						}

						// For each place, get the icon, name and location.
						var bounds = new google.maps.LatLngBounds()

						places.forEach(function(place) {
							if (!place.geometry) {
								console.log('Returned place contains no geometry')
								return
							}

							if (place.geometry.viewport) {
								// Only geocodes have viewport.
								bounds.union(place.geometry.viewport)
							} else {
								bounds.extend(place.geometry.location)
							}
						})

						map.fitBounds(bounds)
					})
				})
		}
	},

	computed: {
		hasSlot() {
			const slotsKeys = Object.keys(this.$slots)
			return slotsKeys.indexOf('fields') >= 0
		},
	},
}
</script>

<style scoped>
.h-100px {
	height: 100px !important;
}
.h-200px {
	height: 200px !important;
}
.h-250px {
	height: 250px !important;
}

.h-240px {
	height: 240px !important;
}

.h-500px {
	height: 500px !important;
}
.map--container {
	display: flex;
	justify-content: center;
	position: relative;
}
.map--container input {
	position: absolute;
	top: 0;

	margin-top: 10px;
}
</style>

